<!-- 全站文件查看 左侧文件浏览+右侧文件列表 -->
<!-- 1.精品案例：允许全部下载，允许单个文件下载 -->
<!-- 2.产品：不允许全部下载，允许单个文件下载 -->
<!-- 3.old.行业资讯：如果是正常的文件列表(市场活动)-同2；如果只是一系列图片预览(白皮书+财报)-不允许下载 -->
<!-- 3.new.行业资讯：内部通过组件可以任意嵌入文件，不再区分行业资讯类型，只允许单个文件下载，不允许全部下载 -->
<!-- 3.new.行业资讯：是否显示右侧文件列表，依据是：是否只有一个文件 -->
<!--
案例下载
type:'case'
id:案例id
fileId:下载单个文件的索引

产品下载
type:'product'
id:产品id
fileId:下载单个文件的索引


行业资讯正文中的纯文件列表下载（不能打包下载）
type:file
id:需要下载的单个文件id
 -->
<template>
  <div
    v-show="!isHidden"
    class="file-viewer-wrapper"
    :class="{ maximized, normal: !maximized && !fullscreen, fullscreen }"
  >
    <div class="viewer-container">
      <component
        :is="currentView.view"
        :key="currentView.id"
        :postfix="currentView.postfix"
        :view-file="currentView.file"
        :single-downloadable="currentView.singleDownloadable"
        :class="[showList && 'with-list']"
        :maximized="maximized"
        :fullscreen="fullscreen"
        @maximize="maximize"
        @restore="restore"
        @fullscreen="fullscreenToggle"
      ></component>
    </div>
    <div
      v-show="!fullscreen"
      class="list-container"
      :class="{ collapsed: !showList }"
    >
      <div
        v-if="!maximized && !fullscreen"
        class="list-toggle"
        @click="showList = !showList"
      >
        <i
          class="iconfont"
          :class="[
            showList ? 'icon-youcefanhuijiantou' : 'icon-zuocefanhuijiantou'
          ]"
        ></i>
      </div>
      <div v-show="maximized || showList" class="list-wrapper">
        <file-viewer-list
          :title="title"
          :subtitle="subtitle"
          :all-downloadable="allDownloadable"
          :sorted-file-list="totalFileList"
          :show-authority="!showAllAuthority"
          :maximized="maximized"
          @change="fileChange"
        >
          <slot slot="header" name="listHeader"></slot>
          <slot slot="footer" name="listFooter"></slot>
        </file-viewer-list>
      </div>
    </div>
  </div>
</template>

<script>
import FileViewerList from './FileViewerList'
import FileViewerImageList from './FileViewerImageList'
import FileViewerImageLarge from './FileViewerImageLarge'
import FileViewerVideo from './video/FileViewerVideo'
import FileViewerArticle from './FileViewerArticle'
import FileViewerZip from './FileViewerZip'
import fullscreen from 'vue-fullscreen'
import Vue from 'vue'
import defVideoPosterSrc from '@/assets/img/common/site-bg-mp4.png'

Vue.use(fullscreen)

export default {
  components: {
    FileViewerList,
    FileViewerImageList,
    FileViewerImageLarge,
    FileViewerVideo,
    FileViewerArticle,
    FileViewerZip
  },
  props: {
    // 因为文件组件公用，该组件内部pkgId可能是案例id，也可能是产品id，或者以后其他内容id
    pkg: {
      type: Object,
      default: () => ({})
    },
    // 是否允许全部下载
    // 全部下载的控制放在文件组件层面，单个文件下载的控制放在单个文件内
    allDownloadable: Boolean,
    // 原始的传递进来的文件列表
    originalFileList: {
      type: Array,
      default: () => []
    },
    // 原始的传递进来的文件列表
    originalArticleList: {
      type: Array,
      default: () => []
    },
    // 文件列表标题
    title: {
      type: String,
      default: '案例资料'
    },
    // 文件列表副标题
    subtitle: {
      type: String,
      default: ''
    },
    // 是否显示对内标签 规则：当外部主体（行业资讯、营销工具）整体为对内时，只在外部主体显示对内标签，文件组件本身不显示
    showAllAuthority: Boolean
  },
  data() {
    return {
      current: 0,
      showList: true,
      maximized: false,
      fullscreen: false,
      isHidden: false
    }
  },
  computed: {
    totalFileList() {
      const fileList = this.originalFileList.map(item => ({
        ...item,
        viewType: 'file'
      }))
      const articleList = this.originalArticleList.map(item => ({
        ...item,
        viewType: 'article'
      }))
      return [...articleList, ...fileList]
    },
    // 当前选中的文件 需要用哪种文件预览组件
    //
    // 当前选中文件 预览的时候 需要的文件属性
    //
    // 未知文件	string	该文件url
    // 列表		[]		文件列表
    // 大图		[]		该大图url
    // 视频		[]		第一个元素为视频url，第二个元素为预览poster
    //
    // 			MP4文件第一张banner图固定为当前案例的第一张banner图；
    // 			第二个MP4开始banner图为后台默认的占位图；
    currentView() {
      let view = ''
      let file = null
      let postfix = ''
      let singleDownloadable = false

      // 当前文件
      const f = this.totalFileList[this.current]
      if (f.viewType === 'article') {
        postfix = 'article'
        view = 'file-viewer-article'
        file = f
      } else {
        // 新接口改为了postfix,为了与老接口进行兼容
        postfix = f.postfix || f.type
        singleDownloadable = f.singleDownloadable
        // 默认值 - 无法识别 - 没有可预览文件
        view = 'file-viewer-zip'
        file = f.url
        let banner = defVideoPosterSrc
        // 需要识别 图片预览是否真的有图片 是否真的有视频
        switch (postfix) {
          case 'mp4':
            // 视频预览图
            if (this.current === 0 && f.banner) {
              banner = f.banner
            }
            // container
            if (f.url || f['video_token']) {
              view = 'file-viewer-video'
            }
            file = {
              url: f.url,
              video_token: f['video_token'],
              banner
            }
            break
          case 'ppt':
          case 'pptx':
          case 'pdf':
          case 'preview':
            // 图片列表是否存在
            if (f.preview && f.preview.length) {
              view = 'file-viewer-image-list'
              file = f.preview
            }
            break
          case 'img':
            // 图片是否存在
            if (f.url) {
              view = 'file-viewer-image-large'
              file = f.url
            }
            break
          case 'zip':
          default:
            break
        }
      }

      return {
        id: f.id,
        view,
        file,
        postfix,
        singleDownloadable,
        authority: f.authority
      }
    }
  },
  destroyed() {
    this.restore()
  },
  methods: {
    maximize() {
      this.maximized = true
      this.isHidden = true
      document.body.classList.add('file-viewer-max')
      this.$nextTick(() => {
        this.isHidden = false
      })
    },
    restore() {
      this.maximized = false
      document.body.classList.remove('file-viewer-max')
    },
    fullscreenToggle(cb) {
      this.$fullscreen.toggle(this.$el, {
        wrap: false,
        callback: fullscreen => {
          this.fullscreenChange(fullscreen)
          if (typeof cb === 'function') {
            cb(fullscreen)
          }
        }
      })
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen
    },
    fileChange(index) {
      this.current = index
    }
  }
}
</script>

<style lang="scss" scoped>
.file-viewer-wrapper {
  display: flex;
  height: 447px;
  background-color: #2c2c31;
  color: #ffffff;
  .list-container {
    position: relative;
    .list-wrapper {
      width: 290px;
      height: 100%;
      overflow: hidden;
    }
    .list-toggle {
      position: absolute;
      left: 0;
      top: 50%;
      margin-top: -26px;
      width: 16px;
      height: 52px;
      line-height: 52px;
      font-size: 12px;
      color: #8e9091;
      background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAA0CAYAAAH0yYjXAAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAEKADAAQAAAABAAAANAAAAAAj3NoMAAABY0lEQVRIDWMwNzd/yQAEjGZmZv9BDCYQAQLEMBgsLCzMQYrJ0w7XBTICBOB2QrjUEWAA+nECzEAQTR9raeIXFEMZGRlfYvgF5lGg5GV2dnZvFB0wSRD9//9/3R8/fjzCqQCmeFQBJCQIhgMLLMRANDD87wPxciYmpuXHjh27AhJjBqbEvdLS0qyqqqq3Hzx48AskiAxwxeZvoClTTpw4UYRLAdgQoHUb8DoSGOUBeBWAjBlVAImR0XCgSzgAE+0nQkFtgqzgP1DHJiCONDAwYDt16hTjyZMnb+PKFyDFD4D+uAykrwCT/2UWFpbL2trat2bNmvUb4j8IicsAZDVY2UCDQRWoLbITsSrEJQh0lThQ7gzZBoAMBhrCR5EBIENGDRgNg9F0AAqB0XQwDMIAWDJvQGmSgSMWP/EbqOkGEO9hY2PrP3To0GMWIOcVUA+o/QauREA0BwfH1QMHDnzBbxZEFgDJC13AjvQ1vwAAAABJRU5ErkJggg==')
        no-repeat center/100% 100%;
      border-radius: 3px 0 0 3px;
      cursor: pointer;
      &:hover {
        color: #ffffff;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAABoCAYAAAHndsJjAAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAIKADAAQAAAABAAAAaAAAAADnzVNBAAAC00lEQVRoBe1av2/TQBR+n92CBIEBBiYGmNmCxF/QgYWhnWDgXwCJhRWJhQUhRiYEUp2oSReQYKhEJQYKxFMcCTFAEVNhANEuqD+O95y4uji+C66RLKoXybHv7t3n7z7fu/O7MzXnzQZZPzTn94yVpsBOyPX/k0HNBXPJpn+YGjfRlqyhAFZ6Xcw5DTLDiQeZFWRnNRgqMVWHmUyxsTNwI+7iYZrHPfHBWGEu4XxYCHC110HLaSBAIOx4SRoyM14DQVEDUUF1GKpQvw48kN0v8CysHQvpyuslfBeibr8A+oGhKDxC0VoL61mr8mc3QN6yIH0+xNGpblNQbz/r0675XQlAkBRANdB+MPQp9QX1hWq+EOB2vBxgbObhqegz8WRCsxT12kiGfc3/j4sLZkUqNUJqry5hy28+WVo8MwHbIOrwEb3r0HNmNhau2TDFALaFdc3vkBIIRo2TdGf1MX5KUSln4nfMM3zc3PxlfnDTnwhAKQZSwf4FwIVSDOzKcm0MvagGQOZsJQBhoQCqgfYDUUD7gWqQdgMdE9UX0o6gc6OOiYdgTOSX8N2qXXmxEgAv+F8/GACwJeGOPIWxkCf1z9wfxwibHG20OXsxXsarXLENAMOQz3igj8wp6saPsJ03Lko74gUGA61zLNXnpW45Eg56+nun6ePfAhfdrCjPQaDI1J03kmmQkiVKhDivWSbZmqW7ZsWIyQdcWMYPn0nejTu4l5X/EwUysDJnWe7lbnyrNgJClkk8PZgflWmq3/ZarQSMMWGtBEQcJaAKqAKqgCqgCqgCqoAqoAqoAqqAKqAKqAKqgCqgCqgCtSrAi9xfayPAN9/hLYHLtRCQNeJzIR1/38Vg6paJf6nXX8qt3JDNjnTjI6C3jQa9zD7N6o2qliPAH49xvQ+8NZPuoAh4OEv9NxF94VY5PyTz0WQC+MYGSbrbMWJ7IqBBmU/e0PLdwl/2Bw2YwPzJt6zvAAAAAElFTkSuQmCC');
      }
    }
  }
  .viewer-container {
    flex: 1;
    width: 0;
  }
  &.maximized {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: auto;
    z-index: 1000;
  }
  &.fullscreen {
    width: 100% !important;
    height: 100% !important;
  }
}
</style>

<style lang="scss">
body.file-viewer-max {
  overflow: hidden;
}
</style>
